import React, { useEffect, useState } from 'react';
import { BookOpen, ArrowRight, Award, CheckCircle } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Live six-pillar learning progress for the organisation admin dashboard. */
export const LearningProgressTile = ({ onOpen = () => {} }) => {
  const userId = localStorage.getItem('cness_username') || 'guest';
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/learning-hub/summary/${encodeURIComponent(userId)}`)
      .then((r) => r.json())
      .then(setSummary)
      .catch(() => setSummary(null));
  }, [userId]);

  if (!summary) return null;
  const done = summary.courses_completed;

  return (
    <button
      onClick={onOpen}
      data-testid="dashboard-learning-tile"
      className="w-full text-left bg-white rounded-xl border-2 border-emerald-200 p-6 hover:shadow-lg transition-shadow"
    >
      <div className="flex items-center justify-between gap-4">
        <span className="flex items-center text-gray-900 font-semibold">
          <BookOpen className="h-5 w-5 text-emerald-700 mr-3" />
          6 Pillars Learning
        </span>
        <span className="text-emerald-700 font-bold" data-testid="dashboard-learning-count">{done}/{summary.courses_total}</span>
      </div>

      <div className="h-2 w-full bg-gray-100 rounded-full mt-4 overflow-hidden">
        <div className="h-full bg-emerald-600 rounded-full transition-all duration-700" style={{ width: `${summary.percent}%` }} />
      </div>

      <div className="flex flex-wrap items-center gap-4 mt-4 text-sm">
        {summary.certificates > 0 && (
          <span className="inline-flex items-center gap-1.5 text-amber-700 font-medium" data-testid="dashboard-learning-certificates">
            <Award className="h-4 w-4" /> {summary.certificates} certificate{summary.certificates === 1 ? '' : 's'}
          </span>
        )}
        {summary.scholar && (
          <span className="inline-flex items-center gap-1.5 text-emerald-700 font-semibold">
            <CheckCircle className="h-4 w-4" /> Six-Pillar Scholar
          </span>
        )}
        {summary.next_course ? (
          <span className="inline-flex items-center gap-1.5 text-gray-600" data-testid="dashboard-learning-next">
            Next: Pillar {summary.next_course.pillar_number} · {summary.next_course.title}
            <ArrowRight className="h-4 w-4" />
          </span>
        ) : (
          <span className="text-emerald-700 font-semibold">All six pillars complete</span>
        )}
      </div>
    </button>
  );
};

export default LearningProgressTile;
